<template lang="pug">
.pickup-delivery
  v-row.px-5
    v-col.px-7(cols="12")
      h2.pa-4.primary--text {{ $t('Shipment.pickupDelivery') }}
  //- Date Range Selectors
  v-row.px-5
    v-col(cols="6", v-if="showPortalField('datePickupFrom', shipmentFields)")
      app-daterange-picker(
        :type="$t('Common.pickup')",
        :datetimeFrom.sync="instance.datePickupFrom",
        :datetimeTo.sync="instance.datePickupTo",
        :specificTime.sync="instance.specificPickupTime",
        :errors="errors",
        parentName="shipment"
      )
    v-col(cols="6", v-if="showPortalField('dateDeliveryFrom', shipmentFields)")
      app-daterange-picker(
        :type="$t('Common.delivery')",
        :datetimeFrom.sync="instance.dateDeliveryFrom",
        :datetimeTo.sync="instance.dateDeliveryTo",
        :specificTime.sync="instance.specificDeliveryTime",
        :errors="errors",
        :disableDateFrom="isASN",
        :disableDateTo="isASN",
        :disableTimeFrom="isASN",
        :disableTimeTo="isASN",
        :disableCheckFrom="isASN",
        :disableCheckTo="isASN",
        parentName="shipment"
      )
  //- Party Contacts From
  v-row.px-5
    v-col(cols="12")
      app-party-contacts(
        v-model="shipmentContactsFrom",
        type="From",
        v-bind="{...slotProps, showInfo: true}",
        vertical,
        :entity="$findEntity('Party')",
        path="partyFrom",
        :extra-load="['PartyFrom.ContactParties.Contact']",
        :isASN="isASN",
        entityAlias="ShipmentContact",
      )
  v-row.px-5
    v-col(cols="12")
      app-party-contacts(
        v-model="shipmentContactsTo",
        type="To",
        v-bind="{...slotProps, showInfo: true}",
        vertical,
        :entity="$findEntity('Party')",
        path="partyTo",
        :extra-load="['PartyTo.ContactParties.Contact']",
        entityAlias="ShipmentContact",
      )
</template>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    shipmentFields: {
      type: Array,
      default: () => ([]),
    },
    // portal: null,
    errors: {
      type: Object,
      default: () => ({}),
    },
    isASN: {
      type: Boolean,
      default: false,
    },
    slotProps: null,
  },
  data: () => ({
    _shipmentContactsFrom: [],
    _shipmentContactsTo: [],
  }),
  methods: {
    showPortalField(fieldName, fields) {
      if (_.isEmpty(this.portal)) return true;
      return (fields || []).find(f => f.name === fieldName);
    },
    overridePortalFields(fieldName, fields) {
      if (!fields) return this.$camelToString(fieldName);
      let field = fields.find(f => f.name === fieldName);
      return (field || {}).label || this.$camelToString(fieldName);
    },
  },
  computed: {
    disablePickupTime() {
      return !this.instance.specificPickupTime;
    },
    disableDeliveryTime() {
      return !this.instance.specificDeliveryTime;
    },
    shipmentContactsFrom:{
      get () {
        if(this.instance.shipmentContacts){
          this._shipmentContactsFrom = this.instance.shipmentContacts.filter(x => x.contactType == 0)
          return this._shipmentContactsFrom;
        }
      },
      set (value) {
        this.instance.shipmentContacts =  this._shipmentContactsTo.concat(value);
      }
    },
    shipmentContactsTo:{
      get () {
        if(this.instance.shipmentContacts){
          this._shipmentContactsTo = this.instance.shipmentContacts.filter(x => x.contactType == 1)
          return this._shipmentContactsTo;
        }
      },
      set (value) {
        this.instance.shipmentContacts =  this._shipmentContactsFrom.concat(value);
      }
    },
  }
}
</script>
